export default class WPFaqModel {
  public id: string = "";
  public date: Date = new Date();
  public pergunta: string = "";
  public resposta: string = "";
  public grupo: string = "Web App Cliente Bem Querer";

  public static toModel(obj: any): WPFaqModel {
    return {
      id: obj.id,
      date: new Date(Date.parse(obj.data)),
      pergunta: obj.pergunta,
      resposta: obj.resposta,
      grupo: "Web App Cliente Bem Querer",
    } as WPFaqModel;
  }
}
